import React from 'react'
import HomeComponent from '../components/HomePage/Home/HomeComponent'
import AboutComponent from '../components/HomePage/About/AboutComponent'
import ServicesComponent from '../components/Services/ServicesComponent'
import WebsiteDesignPhilosophy from '../components/HomePage/WebsiteDesignPhilosophy/WebsiteDesignPhilosophy'
import Timeline from '../components/TimelineWidget/Timeline'

const Home = () => {
  
  return (
    <div className='container'>
      <HomeComponent />
      <AboutComponent />
      <ServicesComponent />
      <WebsiteDesignPhilosophy />
      <Timeline />
    </div>
  )
}

export default Home